/**
 * UserDashboard Component
 * 
 * This component serves as the main dashboard for authenticated users.
 * It includes functionalities such as:
 * - Displaying a loading spinner and messages during application initialization.
 * - Rendering the login page with branding and authentication options.
 * - Integrating the AuthenticationPage component for handling user authentication.
 * 
 * Dependencies:
 * - React for component rendering.
 * - ReactLoading for displaying loading animations.
 * - Azure MSAL for authentication.
 * 
 * Note:
 * - The component is styled to provide a seamless user experience during login and loading phases.
 */
import LoginButton from "./LoginButton";
import { CircularProgress } from "@mui/material";
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { activateEntraExtIDUser, getUserDetailsById } from "../services/services";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from 'react-toastify';
import { fileUploadbtnToastMessages, registrationToastMessages } from "../../common/input-fields/utils/appInputenum";
import { getAdminDetails } from "../../services/services";

const UserDashboard = () => {

  //#region variables
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);

  //#region api get call
  const getUserDetails = async () => {
    const tenantUserId = accounts[0]?.localAccountId || '';
    const isSuperAdmin = accounts[0]?.idTokenClaims?.IsSuperAdmin3 === "True";
    const token = accounts[0]?.idToken || '';
    const userId = accounts[0]?.idTokenClaims?.UserIdInDB
    secureLocalStorage.setItem("userId", userId);
    secureLocalStorage.setItem("userEmail", accounts[0]?.username || '');
    secureLocalStorage.setItem("tenantUserId", tenantUserId);
    const response = await getUserDetailsById(userId);
    if (response.status === 200) {
      setUserDetails(response.data);
      if(response.data.isActive === false) {
        const activateMailResposne = await activateEntraExtIDUser(userId);
      }
      secureLocalStorage.setItem("fullName", response.data.userFullName || '');
    }
    else {
    }
    if(isSuperAdmin) {
      navigate('/global-admin-dashboard');
    }
    else{
      navigate('/dashboard');
    }
  }

  useEffect(() => {
    if (accounts.length > 0) {
      getUserDetails();
    }
  }, [accounts]);

  //#region return
  return (
  <div style={{ width: '100%' }}>
    <div className="login">

      <div className="leftbg">
          <img className="res-logo" src="/icons/LucraLogoWhite.png" alt="Alt360" />
      </div>
      <div className="loadspace">
        <div className="alertMessageLoding">
          Please wait while we are loading application...
        </div>
        <div className="loadingdiv">
          <CircularProgress size={50} style={{ color: '#0078D4' }} />
        </div>
        {
          accounts.length > 0
          ? null
          : <LoginButton />
        }
      </div>
    </div>
  </div>
  )
}

export default UserDashboard
